import React, { useEffect, useState } from "react";
import "./Popup.css";
import { useProperty } from "../../../../PropertyContext";
import { GetResCorporatedetail } from "../../../../Services/Service";

const AccountPopup = ({ show, onClose, onSelect }) => {
  const { selectedProperty } = useProperty();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    const fetchCompanies = async () => {
      if (!selectedProperty?.PropertyID) {
        setCompanies([]);
        return;
      }
      setLoading(true);
      try {
        const result = await GetResCorporatedetail(selectedProperty.PropertyID);
        setCompanies(
          Array.isArray(result)
            ? result.filter((company) => company.TA_Name)
            : [],
        );
      } catch (error) {
        console.log("Error fetching account companies:", error);
        setCompanies([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCompanies();
  }, [selectedProperty]);

  useEffect(() => {
    if (!show) return undefined;
    setSearchText("");
    setSelectedId(null);
    const handleEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [show, onClose]);

  if (!show) return null;

  const searchValue = searchText.replace(/\*/g, "").trim().toLowerCase();
  const filteredCompanies = companies.filter((company) =>
    company.TA_Name.toLowerCase().includes(searchValue),
  );
  const selectedCompany = companies.find(
    (company) => company.CorporateID === selectedId,
  );

  return (
    <div
      className="bon-lookup-backdrop"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        className="modal-dialog modal-dialog-centered bon-lookup-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="accountPopupTitle"
      >
        <div className="modal-content">
          <div className="modal-header bon-lookup-header">
            <h5 id="accountPopupTitle" className="modal-title">
              Search and Select Account
            </h5>
            <button
              type="button"
              className="btn-close bon-popup-close"
              aria-label="Close account popup"
              onClick={onClose}
            />
          </div>
          <div className="modal-body">
            <div className="input-group bon-popup-search">
              <input
                type="search"
                className="form-control"
                placeholder="Search company name"
                value={searchText}
                onChange={(event) => setSearchText(event.target.value)}
                autoFocus
              />
              <button type="button" className="btn bon-search-button">
                Search
              </button>
            </div>
            <div className="table-responsive bon-popup-table-wrap">
              <table className="table table-sm table-hover mb-0 bon-popup-table">
                <thead>
                  <tr>
                    <th scope="col">Company Name</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td className="text-center py-4">Loading companies...</td>
                    </tr>
                  )}
                  {!loading &&
                    filteredCompanies.map((company) => (
                      <tr
                        key={company.CorporateID}
                        className={
                          selectedId === company.CorporateID
                            ? "bon-row-selected"
                            : ""
                        }
                        onClick={() => setSelectedId(company.CorporateID)}
                        onDoubleClick={() => onSelect(company)}
                      >
                        <td>{company.TA_Name}</td>
                      </tr>
                    ))}
                  {!loading && !filteredCompanies.length && (
                    <tr>
                      <td className="text-center py-4">
                        No matching company found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer bon-lookup-footer">
            <button
              type="button"
              className="btn bon-cancel-button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn bon-select-button"
              disabled={!selectedCompany}
              onClick={() => onSelect(selectedCompany)}
            >
              Select
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountPopup;
